export const createSupplierKey = (name) => name
    ? name.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()
    : null;

export const getPlayerTypeLabel = (playerType, isGlobal) => {
    switch (playerType) {
        case 0: return 'LTI 1.1';
        case 1: return !isGlobal ? 'Microlearnings' : 'Online Studio';
        case 2: return 'SCORM';
        case 3: return 'LTI 1.3';
        case 4: return 'Youtube';
        case 5: return 'Vimeo';
        default: return '';
    }
}

export const getPlayerType = (playerType) => {
    switch (playerType) {
        case 0: return 'lti1';
        case 1: return 'onlineStudio';
        case 2: return 'scorm12';
        case 3: return 'lti-advantage';
        case 4: return 'youtube';
        case 5: return 'vimeo';
        default: return '';
    }
}

export const getPlayerTypeValue = (playerTypeString) => {
    switch (playerTypeString.toLowerCase()) {
        case 'lti1': return 0;
        case 'onlineStudio': return 1;
        case 'scorm12': return 2;
        case 'lti-advantage': return 3;
        case 'youtube': return 4;
        case 'vimeo': return 5;
        default: return 999;
    }
}

export const launchTypes = {
    LAUNCHTYPE_REGULAR: 0,
    LAUNCHTYPE_NEWWINDOW: 1,
    LAUNCHTYPE_NEWCHROMELESSWINDOW: 2,
};

